import { getCulture } from '@web-platform/shared-universal-utils-frontend-localisation';
import { getPreferences, PREFERENCES } from 'saddlebag-tracking-preferences';

import { updateEventNumbers } from './updateEventNumbers';

import type { InteractionEvent as InteractionEventSchema } from '@skyscanner-internal/schemas-types/tallyman.pb';
import type { InteractionEventData } from '@web-platform/shared-universal-types-tracking/src/trackInteractionEvent/trackInteractionEvent';

const buildConsentHeader = () => {
  const { market } = getCulture();
  const trackingPreferences = getPreferences(market);

  return {
    isOptedInForOptimisation: trackingPreferences[PREFERENCES.INFORMATION],
    isOptedInForPersonalised: trackingPreferences[PREFERENCES.ADVERTS],
  };
};

export const InteractionEventMessage = (
  eventData: InteractionEventData,
): InteractionEventSchema => {
  const consent = buildConsentHeader();
  const cleanedEventData = updateEventNumbers(eventData);

  return {
    consent,
    name: cleanedEventData.name,
    bools: cleanedEventData.bools || {},
    numbers: cleanedEventData.numbers || {},
    strings: cleanedEventData.strings || {},
  };
};
